import React from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import styles from '../MeterForm.module.scss';

const FormItem = (props) => (
  <Form.Item
    colon={false}
    {...props}
    className={cn(styles.formItem, props.className)}
  />
);

export default FormItem;
